import { Button, makeStyles } from '@material-ui/core'

import { CloudDownload } from '@material-ui/icons'
import React from 'react'
import { csvDownload } from '../utils'
import { csvFormat } from 'd3-dsv'

interface ICsvExport {
  data: any[]
  title: string
  variant?: 'text' | 'outlined' | 'contained' | undefined
  style?: React.CSSProperties
  label?: string
}

const useStyles = makeStyles({
  root: {
    color: '#333',
    padding: 8,
    paddingLeft: 14,
    paddingRight: 14,
    border: 'solid 1px #333',
    marginLeft: 24,
    borderRadius: 6
  }
})

export const CsvSimpleExport = (props: ICsvExport) => {
  const classes = useStyles()
  return (
    <Button
      endIcon={<CloudDownload />}
      className={classes.root}
      style={props.style}
      variant={props.variant}
      onClick={() => {
        const csv = csvFormat(props.data || [], Object.keys(props.data?.[0] || {}))
        csvDownload(csv, props.title)
      }}>
      {props.label || 'Export'}
    </Button>
  )
}
